import React, { useEffect, useState } from 'react';
import PageHeader from '../../components/PageHeader';
import DataTable from '../../components/DataTable';
import Avatar from '../../components/Avatar';
import * as usersApi from '../../api/users.api';
import { errorMessage } from '../../api/client';
import { formatDate } from '../../utils/format';
import { ROLES } from '../../utils/roles';

// End-user list — never mixes clinics, staff, or admins.
// Clinics live under /clinic-approvals, staff/admin under /admins.
function Users() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    usersApi.listAdminUsers({ role: ROLES.USER })
      .then((data) => { if (!cancelled) setRows(data || []); })
      .catch((e) => { if (!cancelled) setErr(errorMessage(e)); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return (
    <>
      <PageHeader title="End users" subtitle="People who sign up to find a clinic and book treatment." />

      <DataTable
        loading={loading}
        rows={rows}
        searchPlaceholder="Search by name, email, phone…"
        columns={[
          {
            key: 'name',
            header: 'User',
            render: (r) => (
              <div className="row">
                <Avatar name={r.name} />
                <div style={{ minWidth: 0, maxWidth: 220 }}>
                  <div className="cell-strong cell-truncate" title={r.name || ''}>{r.name || <span className="muted">—</span>}</div>
                  <div className="muted text-xs cell-truncate" title={r.email || ''}>{r.email || '—'}</div>
                </div>
              </div>
            ),
            accessor: (r) => `${r.name || ''} ${r.email || ''}`
          },
          { key: 'phone', header: 'Phone', render: (r) => r.phone || <span className="muted">—</span> },
          {
            key: 'verified',
            header: 'Phone verified',
            render: (r) => r.phoneVerifiedAt
              ? <span className="badge success">Yes</span>
              : <span className="badge neutral">No</span>
          },
          { key: 'isActive', header: 'Status', render: (r) => r.isActive ? <span className="badge success">Active</span> : <span className="badge neutral">Disabled</span> },
          { key: 'createdAt', header: 'Joined', render: (r) => <span className="muted">{formatDate(r.createdAt)}</span> }
        ]}
        emptyTitle="No end users yet"
        emptyMessage="New sign-ups via phone + OTP will appear here."
      />
      {err && <div className="notice warning" style={{ marginTop: 'var(--s-4)' }}>{err}</div>}
    </>
  );
}

export default Users;
